import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import WoSectionCard from "../common/WoSectionCard";
import TechNotes from "./TechNotes";

// Tech Notes section as an independent card matching the proposals/forms look.
function WoTechNotes({ woId, refreshToken }) {
  const [count, setCount] = useState(0);
  const [searchParams] = useSearchParams();
  // Arriving from a "new tech note" notification: the card has to start open,
  // otherwise the note it points at is hidden behind a collapsed section.
  const openedFromNotification = Boolean(searchParams.get("techNoteId"));

  return (
    <WoSectionCard
      title="Tech Notes"
      count={count}
      forceOpen={openedFromNotification}
      toolTip="This is a place to make a quick note for users on both the Browser and Tech Apps. Viewable by all."
    >
      <TechNotes woId={woId} refreshToken={refreshToken} onCount={setCount} />
    </WoSectionCard>
  );
}

export default WoTechNotes;
